
import { ProfileHeader } from "@/components/ProfileHeader";
import { LinksList } from "@/components/LinksList";
import { SocialLinks } from "@/components/SocialLinks";
import { DesktopHome } from "@/components/DesktopHome";

const Index = () => {
  return (
    <>
      {/* Desktop Version - Hidden on mobile */}
      <div className="hidden md:block">
        <DesktopHome />
      </div>

      {/* Mobile Version - Hidden on desktop */}
      <div className="block md:hidden min-h-screen bg-gradient-to-br from-brand-primary via-brand-primary to-brand-accent">
        <div className="container max-w-md mx-auto px-4 sm:px-6 py-6 sm:py-8 pt-24">
          <ProfileHeader />
          <LinksList />
          <SocialLinks />
        </div>
      </div>
    </>
  );
};

export default Index;
